module.exports = __webpack_public_path__ + "img/feature_buy_en.5bcb0706.png";